const actions = {
  STORE_AHLI_LOAN_DETAILS: "STORE_AHLI_LOAN_DETAILS",
  storeAhliLoanDetails: (payload) => {
    return {
      type: actions.STORE_AHLI_LOAN_DETAILS,
      payload,
    };
  },
};

export default actions;
